import { ElementRef, ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthQuery, AuthService } from '@ascschool/core/auth';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter'; 
import { Announce } from '@ascschool/model/user/announce.model';
import { SizePageService } from '@ascschool/project/size-page/size-page.service'; 
import { SchoolService } from '@ascschool/services/organization/school.service';
import { AnnounceAttachmentService } from '@ascschool/services/user/announce-attachment.service';
import { FileService } from '@ascschool/services/user/announce-file.service';
import { AnnounceViewService } from '@ascschool/services/user/announce-view.service'; 
import { AnnounceService } from '@ascschool/services/user/announce.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal'; 
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-popup-view-noi-dung-thong-bao',
  templateUrl: './popup-view-noi-dung-thong-bao.component.html',
  styleUrls: ['./popup-view-noi-dung-thong-bao.component.scss']
})
export class PopupXemNoiDungThongBaoComponent implements OnInit {
  @Input() value: any;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  
  private elementPageHeaderTable: ElementRef;
  isCollapse = true;
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  fileList: NzUploadFile[] = [];
  validateForm!: FormGroup; 
  announce = new Announce();
  currentUser: any;
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  pageIndex: number = 1; 
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  dataList: any; 
  width: number;
  height: number; 
  heightPagnagation: number = 50;
  commonFilter = new CommonFilter();
  data: any;
  schoolName : string;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,  
    public sizePageService: SizePageService,
    public utilsService: UtilsService,  
    public _authService: AuthService,
    private fileService : FileService,
    private service: AnnounceService,
    private schoolService : SchoolService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {    
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    if(this.value){ 
      this.commonFilter.AnnounceId = this.value
    } 
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    if(this.value){
      this.service.getAnnounceById(this.value.id).subscribe(res=>{
        this.data = res;
        if(this.data != null){
          this.schoolService.GetSelectPagingById(this.data.fromEadId).subscribe(response =>{ 
            
            if(response){ 
              this.schoolName = response.educationAndTrainingName;
            }
          })
        }
      })
    }
    if(this.value.fileId){
      this.getMailfile(this.value.fileId);
    }
   
  }
  getMailfile(id: number){ 
    this.fileService.getFileById(id).subscribe((res)=>{  
      
      
      this.fileList = res.result.map(x => ({
        uid : x.id,
        name : x.fileName,
        status : 'done'
      }));
    });
  }
  downloadfile = (file: any) => { 
    this.fileService.getDownloadUrl(file.uid).subscribe((response) => {
      var a = document.createElement('a');
      a.href = response.url;
      a.target = '_blank';
      a.download = file.name;
      document.body.append(a);
      a.click();
      a.remove();
  });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
 
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
}
